// extracted by mini-css-extract-plugin
export default {"page":"PageTemplate_page__qExdR"};